module.exports = __webpack_public_path__ + "img/bg-lg-05.878c1aad.jpg";